import * as React from 'react';
import { Image } from '@cian/ui-kit';
import { Carousel } from './components/Carousel';
import * as styles from './Gallery.css';

export interface IGalleryProps {
  images: string[];
}

export const Gallery: React.FC<IGalleryProps> = ({ images }) => {
  switch (images.length) {
    case 0:
      return <Image data-name="GalleryPlaceholder" borderRadius="4px" src="" />;
    case 1:
      return <Image data-name="GalleryImage" borderRadius="4px" src={images[0]} />;
    default:
      return (
        <div className={styles['carousel']} data-name="GalleryCarousel">
          <Carousel images={images} />
        </div>
      );
  }
};
